import React, { useEffect, useState } from 'react';

export type ItemsPerPageProps = {
  clients: number;
  lineCards: number;
  cards: number;
};

export const useClientsPerPage = (listRef: React.RefObject<HTMLDivElement>, height:number) => {
  const [clientsPerPage, setClientsPerPage] = useState({ clients: 0, lineCards: 0, cards: 0 } as ItemsPerPageProps);
  useEffect(() => {
    if (listRef.current) {
      const clientHeight = 68;
      const lineCardHeight = 68 + 14;

      const listHeight = listRef.current.clientHeight;
      const calculatedClientsPerPage = Math.floor(listHeight / clientHeight);
      const calculatedLineCardsPerPage = Math.floor(listHeight / lineCardHeight);
      if (clientsPerPage.clients !== calculatedClientsPerPage || clientsPerPage.lineCards !== calculatedLineCardsPerPage) {
        setClientsPerPage((prevState) => ({
          ...prevState,
          clients: calculatedClientsPerPage,
          lineCards: calculatedLineCardsPerPage,
        }));
      }
    }
  }, [listRef, height]);
  return clientsPerPage;
};
